import { ctaClick } from 'store/booking/bookingActions';
import { createCtaClickEvent } from '../eventCreators';
import { createCtaClickEventPayload } from '../dataHelpers/createCtaClickEventPayload';

const emitCtaClickEvent = ({ payload }) => {
  return createCtaClickEvent(
    createCtaClickEventPayload({
      itemText: payload.itemText,
      itemType: payload.itemType,
      url: payload.url,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [ctaClick]: emitCtaClickEvent };
